export default class TopCorrectScoresModel {
  public score: string = null;
  public percentage: number = null;
}
